// import {scrollToContent} from "../utils/common";

const b = benchmark("React App");
import React from 'react';
//import HeroSlider from './containers/HeroSlider'
import "core-js/stable";
import "regenerator-runtime/runtime";
import Main from './components'
import { render } from 'react-dom';
// import { BrowserRouter as Router } from 'react-router-dom';
// import App from '../app';
import store from '../app/store';
import { Provider } from 'react-redux';
// import { BrowserRouter, StaticRouter,Route, Switch } from 'react-router-dom';
// import { ENV_CONFIG } from '../config';
// import ReactGA from 'react-ga';


// import $ from 'jquery';

// import 'material-design-lite/material.min.css';

//Importing Animate CSS
// import 'wowjs/css/libs/animate.css';

//Importing Global styles
import '../styles/core.scss';

// Importing Material JS lib
// import 'material-design-lite/material.min.js';

// import bootstrap from '../config/bootup';

// bootstrap();
// Create app component
const app = document.querySelector('#app');

document.addEventListener('DOMContentLoaded',function(){
    var element = document.getElementsByClassName("actions-nav")[0];
    if(__CLIENT__){
        if(element && window.getComputedStyle(element, null).position == "fixed") {
            document.addEventListener('scroll', fadeSecondaryNav);
        }
    }

})

var timer;
function fadeSecondaryNav(event){
    var element = document.getElementsByClassName('actions-nav')[0];
    if(element) element.style.opacity=0;
    clearTimeout(timer);
    timer = setTimeout(function () {
        if(element) element.style.opacity = 1;
    },100)
}

render(<Provider store={store}>
    <Main />
</Provider>, app);
b.stop();



